import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/lib/integration/react";
import { persistor, store } from "store";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "assets/styles/main.scss";
// Import critical module styles to prevent FOUC
import "modules/settings/assets/styles/main.scss";
import "modules/inventory/assets/styles/main.scss";
import "modules/pharmacy/assets/styles/main.scss";
import "modules/patients/assets/styles/main.scss";
import "modules/reporting/assets/styles/main.scss";
import "modules/finance/assets/styles/main.scss";
import "modules/front-desk/assets/styles/main.scss";
import "modules/onboarding/assets/styles/main.scss";
import "modules/laboratory/assets/styles/main.scss";
import "modules/audit-trail/assets/styles/main.scss";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 2,
    },
  },
});

const container = document.getElementById("root");

if (!container) {
  throw new Error("Root element not found");
}

const root = createRoot(container);

// Putting this here to ensure that the branch id is set before the app renders
const params = new URLSearchParams(window.location.search);
const syncData = params.get("b_id");

if (syncData) {
  localStorage.setItem("hospital-selected-branch", syncData);
}

root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <QueryClientProvider client={queryClient}>
        <App />
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </PersistGate>
  </Provider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
